function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EDEDED"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F33052"
    },
    points: "365.6,398.96 365.6,320.8 267.92,320.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F33052"
    },
    d: "M358.08,336H153.92C117.68,336,88,306.32,88,270.08v-76.16c0-36.24,29.68-65.92,65.92-65.92h204.16 c36.24,0,65.92,29.68,65.92,65.92v76.16C424,306.4,394.32,336,358.08,336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M147.12,254.08c3.76,2.48,10.4,5.04,16.8,5.04c9.28,0,13.6-4.64,13.6-10.4 c0-6.08-3.6-9.44-13.04-12.88c-12.56-4.48-18.56-11.44-18.56-19.84c0-11.28,9.12-20.56,24.16-20.56c7.12,0,13.28,2,17.2,4.32 l-3.2,9.28c-2.72-1.76-7.84-4.08-14.32-4.08c-7.52,0-11.76,4.32-11.76,9.52c0,5.76,4.16,8.4,13.28,11.84 c12.16,4.64,18.4,10.72,18.4,21.12c0,12.32-9.52,20.96-26.16,20.96c-7.68,0-14.8-1.92-19.68-4.8L147.12,254.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.24,216c0-7.2-0.16-13.2-0.56-18.96h11.12l0.56,11.28h0.4c3.92-6.64,10.4-12.88,22-12.88 c9.52,0,16.8,5.76,19.84,14.08h0.32c2.16-3.92,4.88-6.96,7.84-9.12c4.24-3.2,8.8-4.96,15.52-4.96c9.28,0,23.04,6.08,23.04,30.4 v41.28h-12.48v-39.68c0-13.44-4.96-21.6-15.2-21.6c-7.2,0-12.88,5.36-15.04,11.6c-0.56,1.76-1.04,4.08-1.04,6.4v43.28h-12.48v-42 c0-11.12-4.88-19.28-14.64-19.28c-7.92,0-13.76,6.4-15.76,12.72c-0.72,1.92-1.04,4.08-1.04,6.24v42.24h-12.48V216H206.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.28,254.08c3.76,2.48,10.4,5.04,16.8,5.04c9.28,0,13.6-4.64,13.6-10.4 c0-6.08-3.6-9.44-13.04-12.88c-12.56-4.48-18.56-11.44-18.56-19.84c0-11.28,9.12-20.56,24.16-20.56c7.12,0,13.28,2,17.2,4.32 l-3.2,9.28c-2.72-1.76-7.84-4.08-14.32-4.08c-7.52,0-11.76,4.32-11.76,9.52c0,5.76,4.16,8.4,13.28,11.84 c12.16,4.64,18.4,10.72,18.4,21.12c0,12.32-9.52,20.96-26.16,20.96c-7.68,0-14.8-1.92-19.68-4.8L325.28,254.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.1b3cdee8c84baf1012b065fe55a7064c.svg";
export { ForwardRef as ReactComponent };